const movieHasNoLength = length => length === false || length === '0' || length === 0 || !length

export default movieHasNoLength